import React from "react";
import Modal from "react-bootstrap/Modal"
import Form from "react-bootstrap/Form"
import ErrorMessage from "../parts/ErrorMessage";
import Spinner from "react-bootstrap/Spinner";
import Alert from "react-bootstrap/Alert";

function OrdinaFormModal(props){
    return <Modal show={props.orderModal} onHide={props.closeOrderModal} centered>
        <Modal.Header closeButton>
            <Modal.Title>Completa il tuo ordine</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <ErrorMessage where={"modal"} />
            <OrdinaForm config={props.config}
                        fasceOrarie={props.fasceOrarie}
                        domicilio={props.domicilio}
                        orderConfirm={props.orderConfirm}
                        modalLoading={props.modalLoading}/>
        </Modal.Body>
        <Modal.Footer>
            <button type="submit" className="btn btn-aggiungi" form={"ordine-form"} disabled={props.modalLoading}><i className="fab fa-whatsapp"></i> Ordina ora</button>
        </Modal.Footer>
    </Modal>;
}

class OrdinaForm extends React.Component{
    constructor(props) {
        super(props);
        let today = new Date();
        let nowValue = today.getHours()+(today.getMinutes()/100);
        let fasceOrarie = this.props.fasceOrarie.filter((f) => {
            // Check if the the end of the slot is greater than now
            let fineFascia = parseFloat(f.fascia.substr(8))
            return nowValue < fineFascia && f.currentVal < f.order_limit;
        })

        let oraConsegna = fasceOrarie.length > 0 ? fasceOrarie[0].fascia : 0;
        this.state = {nome: "", cognome: "", indirizzo: "", note: "", fasceOrarie: fasceOrarie, oraConsegna: oraConsegna}
    }

    updateField = (name, value) => {
        this.setState({[name]: value});
    }

    confermaOrdine = (ev) => {
        ev.preventDefault();

        let form = ev.currentTarget;

        if(form.checkValidity()){
            this.props.orderConfirm({nome: this.state.nome,
                                    cognome: this.state.cognome,
                                    indirizzo: this.state.indirizzo,
                                    oraConsegna: this.state.oraConsegna,
                                    note: this.state.note});
        }
    }

    render() {
        if(this.props.modalLoading){
            return <div className={"text-center"}>
                <Spinner animation="grow" variant="warning"/>
            </div>
        }
        return <Form onSubmit={this.confermaOrdine} id={"ordine-form"}>
            {
                this.state.fasceOrarie.length === 0 && <Alert variant={"danger"}><i className="fas fa-sad-cry"></i> Siamo spiacenti, per oggi non sono presenti altre fasce orarie disponibili per la consegna. Torna domani!</Alert>
            }
            <Form.Group controlId="nome">
                <Form.Control type="text" name="nome" value={this.state.nome} placeholder={"Nome"}
                              onChange={(ev) => this.updateField(ev.target.name, ev.target.value)} required
                              autoFocus/>
            </Form.Group>
            <Form.Group controlId="cognome">
                <Form.Control type="text" name="cognome" value={this.state.cognome} placeholder={"Cognome"}
                              onChange={(ev) => this.updateField(ev.target.name, ev.target.value)} required/>
            </Form.Group>
            {
                this.props.domicilio &&
                <Form.Group controlId="indirizzo">
                    <Form.Control type="text" name="indirizzo" value={this.state.indirizzo} placeholder={"Indirizzo consegna"}
                                  onChange={(ev) => this.updateField(ev.target.name, ev.target.value)} required/>
                </Form.Group>
            }
            <Form.Group controlId="fasciaOraria">
                <Form.Label>Ora consegna</Form.Label>
                <Form.Control as="select" name="oraConsegna" onChange={(ev) => this.updateField(ev.target.name, ev.target.value)}
                              value={this.state.oraConsegna}
                              custom
                              required>
                    {
                        this.state.fasceOrarie.map((f) =>
                            <option value={f.fascia}
                                    key={f.fascia}>{f.fascia}</option>
                        )
                    }
                </Form.Control>
            </Form.Group>
            <Form.Group controlId="exampleForm.ControlTextarea1">
                <Form.Label>Note</Form.Label>
                <Form.Control as="textarea" rows={3} name={"note"} onChange={(ev) => this.updateField(ev.target.name, ev.target.value)}
                              placeholder={"Scrivi qui note per il ristorante o segnala eventuali intolleranze alimentari"}/>
            </Form.Group>
            <div id={"ordine-privacy"}>Inviando l'ordine si dichiara di aver letto e compreso l'<a href={"https://sushinikko.it/privacy-policy/"} target={"_blanck"}>informativa sul trattamento dei dati personali</a> accettandola in ogni suo punto.</div>
        </Form>;
    }
}

export default OrdinaFormModal;
